// APP
export const HORECA_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://app.bakarta.com/'
    : 'https://horecadev.bakarta.com/'
export const MENU_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://mybakarta.com/'
    : 'https://bakarta-menu-dev.web.app/'
// COOKIE
export const BAKARTA_COOKIE = 'bakarta_session_id'
export const BAKARTA_COOKIE_OPTIONS = {
  domain: process.env.NODE_ENV === 'production' ? '.bakarta.com' : null,
  expires: 7,
  secure: process.env.NODE_ENV === 'production'
}
// API SERVER
// export const URL_API_ENDPOINT =
//   process.env.NODE_ENV === 'production'
//     ? 'https://us-central1-bakarta-dev.cloudfunctions.net/onRequest-api'
//     : 'http://localhost:7001/bakarta-dev/us-central1/onRequest-api'
export const URL_API_ENDPOINT =
  process.env.NODE_ENV === 'production'
    ? 'https://europe-west1-bakarta-kustovi.cloudfunctions.net/onRequest-api'
    : 'http://localhost:7001/bakarta-dev/us-central1/onRequest-api'
// ADDONS
export const ADDONS = {
  contact: 'contact',
  company: 'company',
  place: 'place'
}
// ROLES
export const ROLES = {
  horeca_admin: {
    label: 'Admin horeca',
    value: 'horeca_admin'
  },
  partner_partner: {
    label: 'Partner',
    value: 'partner_partner'
  },
  partner_brand: {
    label: 'Brand',
    value: 'partner_brand'
  }
}
export const PACKAGES = {
  free: {
    label: 'FREE',
    value: 'free'
  },
  pro: {
    label: 'PRO',
    value: 'pro'
  }
}
// VUEX (persistance)
export const VUEX_PERSISTED_KEY = 'bakarta_partner'
// COMPANIES
export const COMPANY_TYPES = {
  brand: 'brand',
  horeca: 'horeca',
  partner: 'partner'
}
export const COMPANY_TYPES_BILLING = {
  person: {
    value: 'person',
    label: 'Persona física'
  },
  selfEmployed: {
    value: 'selfEmployed',
    label: 'Autónomo'
  },
  company: {
    value: 'company',
    label: 'Empresa'
  }
}
// BRAND
export const BRAND_REQUEST_EMAIL = 'mhernandez@kustovi.com'
export const BRAND_REQUEST_STATUS = {
  approved: {
    value: 'approved',
    label: 'Aprobada'
  },
  notSend: {
    value: 'notSend',
    label: 'No enviada'
  },
  pending: {
    value: 'pending',
    label: 'Pendiente'
  },
  rejected: {
    value: 'rejected',
    label: 'Rechazada'
  }
}
// REFERRAL STATE
export const REFERRALS_STATE = {
  pending: {
    label: 'Pendiente',
    value: 'pending'
  },
  activated: {
    label: 'Activado',
    value: 'activated'
  }
}
// RELATIONSHIP
export const COMPANY_RELATIONSHIP_TYPES = {
  partner: 'partner',
  brand: 'brand',
  referred: 'referred'
}
export const COMPANY_RELATIONSHIP_STATUS = {
  pending: 'pending',
  accepted: 'accepted',
  rejected: 'rejected',
  canceled: 'canceled'
}
